/**
 * Error Boundary Component
 * (TS Migrated)
 */

import React, { ErrorInfo, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { lastTraceId } from '../api';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Chat Component Crashed:", error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', color: 'var(--color-error)', textAlign: 'center', background: 'var(--bg-surface)', height: '100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center' }}>
          <AlertTriangle size={40} style={{marginBottom:'10px'}} />
          <h3>Panel Crashed</h3>
          <p style={{fontSize:'0.8rem', opacity: 0.8}}>The AI sent a response that broke the display.</p>
          {lastTraceId && (
            <div style={{ marginTop: '10px', fontSize: '0.7rem', color: 'var(--text-secondary)', background: 'var(--bg-app)', padding: '4px 8px', borderRadius: '4px', border: '1px solid var(--border)' }}>
              Trace ID: {lastTraceId}
            </div>
          )}
          <button 
            onClick={() => this.setState({ hasError: false })}
            style={{marginTop:'15px', padding:'8px 16px', background:'var(--bg-surface-alt)', color:'var(--text-primary)', border:'none', borderRadius:'4px', cursor:'pointer'}}
          >
            Try to Reload UI
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
